import { useLocation } from 'react-router-dom';
import { Button, TextField, Grid, Typography, MenuItem, LinearProgress } from "@mui/material";
import { useEffect, useState } from 'react';
import { apiRequest } from '../functions/apiRequest';
import CustomAliceCarousel from '../customComponents/customAliceCarousel';
import config from '../config.json';
import { toast } from 'react-toastify';

const gridStyle = {
    border: '1px solid #ccc', // Grey outline
    boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.5)', // Shadow
    padding: '16px', // Add padding for spacing    
    cursor: 'pointer',
};

const noEmployeeDrives = ['3']

export default function CouponDonationPage({ isMobile }) {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const driveId = queryParams.get('drive_id');
    const initialFormData = Object.freeze({
        employee_id: null,
        drive_id: parseInt(driveId),
        donator_email: null,
        category: null,
        program: null
    });

    const [isLoading, setIsLoading] = useState(true)
    const [categories, setCategories] = useState([]);
    const [couponDetails, setCouponDetails] = useState([]);
    const [formData, updateFormData] = useState(initialFormData);
    const [couponRedeemed, setCouponRedeemed] = useState(false);
    const [selectedIdx, setSelectedIdx] = useState(-1);
    const [categoryPrograms, setCategoryPrograms] = useState([]);
    const [categoryStats, setCategoryStats] = useState([]);
    const [donationMultiplier, setDonationMultiplier] = useState(2);

    const handleChange = (e) => {
        updateFormData({
            ...formData,
            // Trimming any whitespace
            [e.target.name]: e.target.value,
        });
    };

    const redeemCoupon = async () => {
        try {
            setIsLoading(true);
            formData.donator_email = formData.donator_email.toLowerCase();
            if (noEmployeeDrives.includes(driveId)) {
                formData.employee_id = formData.donator_email;
            }
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const validEmail = emailRegex.test(formData.donator_email);
            if (!validEmail) {
                throw Error('Please enter a valid email ID');
            }
            let keys = Object.keys(formData);
            let values = Object.values(formData);
            let idx = values.indexOf(null)
            if (idx > -1) throw Error(`${keys[idx]} is empty, Please fill the field`);
            if (parseFloat(formData.amount) <= 0 || parseFloat(formData.amount) > parseFloat(couponDetails.coupon_amount)) throw Error(`Please enter a valid amount greater than 0 and less than or equal to ${couponDetails.coupon_amount}`);
            const redeemResponse = await apiRequest('POST', JSON.stringify(formData), '/coupon/redeem', null, null, null, true);
            if (redeemResponse.data.error) {
                toast.error(redeemResponse.data.error)
                updateFormData(initialFormData);
                setSelectedIdx(-1);
            } else {
                toast.success(redeemResponse.data.message);
                setCategoryStats(redeemResponse.data.response.response_data);
                setCouponRedeemed(true);
            }
        } catch (err) {
            toast.error(err.message)
        }
        setIsLoading(false);
    }

    const getAllImages = (categories) => {
        let images = []
        categories.forEach(category => images = [...images, ...category.images]);
        return images;
    }

    const handleSelect = (categoryName) => {
        let idx = categories.findIndex(category => { return category.name === categoryName })
        setSelectedIdx(idx);
        setCategoryPrograms(categories[idx].program_id_list);
        updateFormData({
            ...formData,
            // Trimming any whitespace
            category: categoryName,
            program: categories[idx].program_id_list[0].program_id
        });
    }

    useEffect(() => {
        async function fetchData() {
            const data = await apiRequest('get', null, `/coupon/details/${driveId}`);
            setCategories(data.categories);
            setCouponDetails(data.coupon_details);
            if (data.coupon_details.multiplier) {
                setDonationMultiplier(data.coupon_details.multiplier)
            }
            updateFormData({ ...formData, amount: data.coupon_details.coupon_amount });
            setIsLoading(false);
        }
        fetchData();
        // eslint-disable-next-line
    }, []);
    if (!isLoading && !couponRedeemed) {
        return (
            <Grid>
                <Grid container spacing={4} style={{ padding: '30px' }} justifyContent='center'>
                    <Grid item xs={12} md={12} >
                        <Typography style={{ fontSize: '20pt', textAlign: 'center', fontFamily: 'Raleway' }}>
                            {couponDetails.company} Donation Drive
                        </Typography>
                        <Typography style={{ fontSize: '20pt', textAlign: 'center', fontFamily: 'Raleway' }} hidden={noEmployeeDrives.includes(driveId)}>
                            You the employee decide {couponDetails.company}'s social giving donation
                        </Typography>
                        <Typography style={{ fontSize: '20pt', textAlign: 'center', fontFamily: 'Raleway' }} hidden={driveId !== '10'}>
                            Choose your favorite CSR project and  {couponDetails.company} will match it 5X
                        </Typography>
                        <Typography style={{ fontSize: '15pt', textAlign: 'center', fontFamily: 'Raleway' }}>
                            Click on a Category!
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Grid container justifyContent='center'>
                            {categories.map((category, idx) => <Grid item xs={12} md={4} key={category.name} style={{ padding: isMobile ? '0px 0px 10px 0px' : '20px' }} onClick={() => { handleSelect(category.name) }}>
                                <Grid style={{ ...gridStyle, backgroundColor: idx === selectedIdx ? 'rgba(0, 255, 0, 0.4)' : 'transparent' }}>
                                    <CustomAliceCarousel images={category.images} autoPlayInterval={2000} />
                                    <Typography style={{ fontSize: '20pt', textAlign: 'center', fontFamily: 'Raleway' }}>
                                        {category.name}
                                    </Typography>
                                    <Typography style={{ fontSize: '15pt', textAlign: 'center', fontFamily: 'Raleway' }}>
                                        {category.description}
                                    </Typography>
                                </Grid>
                            </Grid>)}
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Grid container spacing={4} justifyContent='center'>
                            <Grid item xs={10} md={4}>
                                <TextField
                                    select
                                    label='Choose a program to donate'
                                    fullWidth
                                    placeholder='Who is your donation for?'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={formData['program']}
                                    onChange={(e) => { handleChange(e); }}
                                    id='program'
                                    name='program'
                                >
                                    {categoryPrograms.map((program) => (
                                        <MenuItem key={program.program_id} value={program.program_id}>
                                            {program.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={10} md={4}>
                                <TextField
                                    label='Amount to Redeem (Optional)'
                                    fullWidth
                                    placeholder='Amount to Redeem'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    id='amount'
                                    name='amount'
                                    onChange={handleChange}
                                >
                                </TextField>
                            </Grid>
                            <Grid item xs={10} md={4}>
                                <TextField
                                    label='Your Email'
                                    fullWidth
                                    placeholder='Your Email'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    id='donator_email'
                                    name='donator_email'
                                    onChange={handleChange}
                                >
                                </TextField>
                            </Grid>
                            <Grid item xs={10} md={4} hidden={noEmployeeDrives.includes(driveId)}>
                                <TextField
                                    label='Your Employee ID'
                                    fullWidth
                                    placeholder='Your Employee ID'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    id='employee_id'
                                    name='employee_id'
                                    onChange={handleChange}
                                >
                                </TextField>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button onClick={redeemCoupon} style={{ backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.websiteColor, color: 'white' }}>Redeem {formData.amount}₹ out of {couponDetails.coupon_amount}₹ CSR Voucher!</Button>
                    </Grid>
                </Grid>
            </Grid >
        )
    } else if (!isLoading && couponRedeemed) {
        return (<Grid style={{ padding: isMobile ? '5px' : '20px' }}>
            <Grid container style={gridStyle} justifyContent='center' spacing={3}>
                <Grid item xs={12} md={6} style={gridStyle} >
                    <CustomAliceCarousel images={getAllImages(categories)} autoPlayInterval={2000} height="50vh" />
                </Grid>
                <Grid item xs={12} md={12} style={{ textAlign: 'center' }}>
                    <Typography variant="h3" style={{ fontFamily: 'Raleway' }}> Thank you for redeeming your coupon!</Typography>
                </Grid>
                <Grid item xs={12} md={12} style={{ textAlign: 'center' }}>
                    <Typography variant="h5" style={{ fontFamily: 'Raleway' }}> Please click <a rel="noreferrer" target="_blank" href={`${window.location.origin}/donate?drive_id=${driveId}&coupon_drive=true&company=${encodeURIComponent(couponDetails.company)}`}>here</a> if you would like to donate more! Your donation would be eligible for 80G Tax Rebate</Typography>
                </Grid>
                <Grid item xs={12} md={12} style={{ textAlign: 'center' }} hidden={noEmployeeDrives.includes(driveId)}>
                    <Typography variant="h4" style={{ fontFamily: 'Raleway' }}> Your donation of ₹{formData.amount} x {donationMultiplier} = ₹{formData.amount * donationMultiplier} will help us make a greater impact in {formData.category}</Typography>
                </Grid>
                <Grid item xs={12} md={12} style={{ textAlign: 'center' }} hidden={noEmployeeDrives.includes(driveId)}>
                    {categoryStats.map(stat => <Typography variant="h4" style={{ fontFamily: 'Raleway' }} key={stat.category}> <b>{couponDetails.company}</b> has already raised <b>₹{stat.total_amount}</b> x {donationMultiplier} = <b>₹{stat.total_amount * donationMultiplier}</b> for <b>{stat.category}</b> with this drive!</Typography>)}
                </Grid>
                <Grid item xs={12} md={12} style={{ textAlign: 'center' }} hidden={noEmployeeDrives.includes(driveId)}>
                    <Typography variant="h5" style={{ fontFamily: 'Raleway' }}> <b>{couponDetails.company}</b> has generously agreed to match every donation you make!</Typography>
                </Grid>
            </Grid>
        </Grid>)
    } else if (isLoading) {
        return (
            <div style={{ marginTop: 20, textAlign: 'center' }}>
                <img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
                <LinearProgress />
            </div>
        )
    }
}